export default {
	Title: 'Thiết lập khoản nộp NSNN',
	WarningInactive:
		'Tờ khai đã bị ngừng thiết lập khoản nộp ngân sách. Từ giờ bạn không thể nộp thuế từ tờ khai này.',
	WarningActive:
		'Tờ khai đã được thiết lập khoản nộp ngân sách. Từ giờ bạn có thể nộp thuế từ tờ khai theo thiết lập đã chọn.',
	StateBudget: {
		Declaration: 'Tờ khai',
		SubmitToSubsection: 'Nộp cho tiểu mục'
	},
	StateBudgetDetail: {
		TypeTax: 'Loại thuế',
		SubmitToSubsection: 'Nộp vào tiểu mục',
		PlaceholderEconomic: 'Nhập tên/mã tiểu mục',
		Economic: 'Tiểu mục',
		EconomicCode: 'Mã tiểu mục',
		ResetDefault: 'Đặt lại mặc định',
		Code: 'Mã',
		ProductName: 'Tên hàng hóa, dịch vụ/Ngành nghề',
		ProductAndService: 'Hàng hóa, dịch vụ',
		Product: 'Hàng hóa',
		TypeWork: 'Ngành nghề',
		TypesOfMinerals: 'Loại kháng sản',
		FeesAndCharges: 'Phí, lệ phí',
		ResourceType: 'Loại tài nguyên',
		PlaceholderProductService: 'Nhập mã/tên hàng hóa, dịch vụ',
		PlaceholderProduct: 'Nhập mã/tên hàng hóa',
		PlaceholderMineral: 'Nhập mã/tên khoáng sản',
		PlaceholderFees: 'Nhập mã/tên phí, lệ phí',
		PlaceholderResource: 'Nhập mã/tên tài nguyên',
		PlaceholderTypeWork: 'Nhập mã/tên nghành nghề',
		PlaceholderCodeName: 'Nhập mã/tên',
		WarningWhenSaveSuccess: 'Cập nhật khoảng nộp NSNN thành công',
		WarningClosePopup:
			'Dữ liệu chưa được lưu, bạn có muốn tiếp tục đóng màn hình này?',
		WarningWhenSave:
			'Xác nhận thay đổi. Sau khi lưu thay đổi, MISA sẽ căn cứ vào thiết lập mới để xác định tình trạng nộp thuế của tờ khai. Bạn có muốn tiếp tục?'
	}
};
